import { TAbstractCatalogItem } from './AbstractCatalogItem'

export interface TSingleCatalogItem extends TAbstractCatalogItem {
  displayInWeb: boolean
  alerts: {
    confirmationAlert: string
    selectedServiceAlert: string
    selectedServiceBlock: boolean
    confirmationEmailAlert: string
    useConfirmationSmsAlert: boolean
    confirmationSmsAlert: string
  }
}

export const create = (data?: Partial<TSingleCatalogItem>): TSingleCatalogItem => ({
  _id: '',
  id: 0,
  active: true,
  parentId: 0,
  catalogId: '',
  isCategory: false,
  extraId: '',
  name: '',
  order: 0,
  fields: [],
  path: '',
  displayInWeb: true,
  alerts: {
    confirmationAlert: '', // Виджет
    selectedServiceAlert: '', // Текст для уведомления при выборе услуги
    selectedServiceBlock: false,
    confirmationEmailAlert: '', // E-mail
    useConfirmationSmsAlert: false, // Отправить по SMS
    confirmationSmsAlert: '',
  },
  ...data,
})
